/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TerminalFirmwareEnum {
    NONE = 'None',
    INGENICO_RBA = 'Ingenico_rba',
    INGENICO_UPP = 'Ingenico_upp',
}